<template>
  <vs-card class="cstm_vx_card mb-4"  v-if="maximize==1">
    <div slot="header" class="flex flex-wrap justify-between items-center w-full">
      <h4>Summary</h4>
      <div class="inline-flex">
         <vs-tooltip text="Summary Settings"><vs-button class="ml-2"  @click="popupActivo=true" radius color="primary" type="filled" icon="insights"></vs-button></vs-tooltip>
      </div>
    </div>
   <div class="vx-row flex flex-wrap">
        <!-- <pre>{{list_of_analytics_array}}</pre> -->
        <!-- <template v-for="analytic in list_of_analytics_array"> -->
           
            <div v-for="(each_value, index1) in list_of_analytics_array" :key="index1" class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 mb-4">
              <statistics-card-line
                hideChart
                class="h-full"
                :module_name="each_value.module_name"
                :icon="each_value.module_icon"
                icon-right
                :statistic="each_value.count"
                :statisticTitle="each_value.selected_value ? `${each_value.selected_value}` : each_value.option_name"
                :statisticSubTitle="each_value.selected_value != null ? each_value.selected_value : 'Nothing selected'"
              />
            </div>
        <!-- </template> -->
      </div>
       <vs-popup class="medium"  title="Add Summary" :active.sync="popupActivo">
      <summeryMOdal :module="module_id" @savesummery="savesummery"></summeryMOdal>
     </vs-popup>
  </vs-card>
</template>

<script>
import {mapActions,mapGetters} from 'vuex'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import summeryMOdal from './summeryModal'
import { getUserAnalytics } from '@/api/analyticsSettings'

export default {
  components: {
    StatisticsCardLine,
    summeryMOdal
  },
    watch: {
    get_maxi_min(){
      this.maximize=this.get_maxi_min
    }
  },
  props: {
    value: {},
    module_id: {
      type: Number
    }
  },

  created () {
    this.getUserAnalytics()
  },
  data () {
    return {
       maximize:0,
      module:'',
      list_of_analytics_array: [],
      popupActivo:false
    }
  },
  methods: {
     ...mapActions(['SET_ATTENDANCE_SINGLE_STUDENT_ID','SET_Analytics_STATUS','SET_Analytics_Maxi_Min_STATUS']),
    savesummery () {
      
      this.getUserAnalytics()
      this.popupActivo = false
    },
    async getUserAnalytics () {
      const customer_id = localStorage.getItem('customer_id')
      const PLATFORM_MODULE_ID = this.module_id
      const summery_id = 0
      try {
        const data = await getUserAnalytics(PLATFORM_MODULE_ID, customer_id, summery_id)
        if (PLATFORM_MODULE_ID === 8) {
          this.list_of_analytics_array = (data.data.data.analytics).flat()
        }
        const data1 = await getUserAnalytics(45, customer_id, summery_id)
        const list = data1.data.data.analytics.flat(1)
        this.list_of_analytics_array.push(list)
        this.list_of_analytics_array = this.list_of_analytics_array.flat()

         const view_state =data.data.data.view_state
        view_state.module_id =PLATFORM_MODULE_ID
        this.SET_Analytics_STATUS(view_state)

        const view_maxi_min=data.data.data.view_state.view_state
        this.SET_Analytics_Maxi_Min_STATUS(view_maxi_min)
        
      } catch (error) {
        
      }
    }
  },
  computed: {
     ...mapGetters(['get_maxi_min']),
    localValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
